import type { SqlObjectV2 } from "@bezpart-board/shared";
import { nextZIndex } from "../../editor/zIndex";
import { SQL_DEFAULTS } from "./sqlLogic";

export const SQL_DEFAULT_SIZE = { w: 780, h: 580 } as const;

/** Виджет «SQL», центрированный в (cx, cy). */
export function createSqlObject(
  cx: number,
  cy: number,
  existingObjects: { zIndex?: string }[] = []
): SqlObjectV2 {
  const { w, h } = SQL_DEFAULT_SIZE;
  const d = SQL_DEFAULTS;
  return {
    id: crypto.randomUUID(),
    type: "sql",
    x: Math.round(cx - w / 2),
    y: Math.round(cy - h / 2),
    w,
    h,
    dataset: d.dataset,
    mode: d.mode,
    setupSql: d.setupSql,
    query: d.query,
    taskIndex: 0,
    customPrompt: d.customPrompt,
    customSolution: d.customSolution,
    status: "idle",
    output: "",
    solvedIds: [],
    showSchema: true,
    zIndex: nextZIndex(existingObjects),
  };
}
